import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss']
})
export class JobComponent implements OnInit {
  perfActive: Boolean;
  designActive: Boolean;
  manActive: Boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
  ) {}

  ngOnInit() {

    this.perfActive = this.location.path().includes("performance")
    this.designActive = this.location.path().includes("design")
    this.manActive = this.location.path().includes("management")

    this.router.events.subscribe((val) => {
      this.perfActive = this.location.path().includes("performance")
      this.designActive = this.location.path().includes("design")
      this.manActive = this.location.path().includes("management")
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/job/job.component.ts